import { Trans, useTranslation } from 'react-i18next';

import logo from '../../../images/pCon_logo.svg';
import { appStore } from '../../../stores/AppStore';

import { openLink } from '@egr/xbox/utils/Url';
import { makeStyles } from '@egr/xbox/utils/tss-react';

const useStyles = makeStyles({ name: 'ViewerContainer' })((theme) => ({
    watermark: {
        position: 'absolute',
        bottom: 5,
        right: 5,
        fontWeight: 400,
        fontSize: 11,
        textShadow: '0 0 1px #ffffff',
        display: 'flex',
    },
    logo: {
        height: 15,
        marginTop: 1,
        marginLeft: 4,
    },
}));

export const Watermark: React.FC = () => {
    const { classes } = useStyles();
    const { embed } = appStore.useState(['embed']);
    const [t] = useTranslation();

    if (!embed) {
        return;
    }

    return (
        <div
            id="watermark"
            className={classes.watermark}
            onClick={() => openLink('https://pcon-solutions.com/')}
            style={{ cursor: 'pointer' }}
        >
            <Trans t={t}>
                powered by{' '}
                <img
                    src={logo}
                    className={classes?.logo}
                />
            </Trans>
        </div>
    );
};
